// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JFZ1dpB4hGmnPW {
  display: inherit;
  position: relative;
  top: var(--ds-space-025, 2px);
  align-items: baseline;
  max-height: 32px;
  margin-right: var(--ds-space-050, 4px);
  padding: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-025, 2px);
  overflow: visible;
  line-height: 32px;
}
.H5G4QHRDmrL8T5 {
  overflow: visible;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardFacepile": `JFZ1dpB4hGmnPW`,
	"inviteDialog": `H5G4QHRDmrL8T5`
};
export default ___CSS_LOADER_EXPORT___;
